import type { AllowedVenueUploadResponse, AllowedVenueUploadSummary } from 'c-sdk';

/**
 * UL-7912 -- the allowed venue upload's dry-run summary, as the dialog shows it.
 *
 * The summary is the point, not the success: rows read against rows derived is what shows a plan
 * that lost a network on the way.
 */

/** Enough rejections to see the pattern without burying the summary. */
export const REJECTIONS_SHOWN = 10;

const PREFIX = 'Modules.Main.Campaigns.CampaignSchedule.dsp.venues';

export type AllowedVenueSummaryRow = {
    labelKey: string;
    labelParams?: Record<string, string>;
    value: number;
};

export const allowedVenueSummaryRows = (
    preview: AllowedVenueUploadResponse | null,
): AllowedVenueSummaryRow[] => {
    const summary = preview?.summary;
    if (!summary) return [];

    const previous = preview?.previous;

    return [
        { labelKey: `${PREFIX}.rowsRead`, value: summary.rows_read },
        { labelKey: `${PREFIX}.derived`, value: summary.inserted },
        { labelKey: `${PREFIX}.duplicates`, value: summary.duplicates },
        { labelKey: `${PREFIX}.rejected`, value: summary.rejected },
        previous?.uploaded_at
            ? {
                  labelKey: `${PREFIX}.replaces`,
                  labelParams: { date: previous.uploaded_at.slice(0, 10) },
                  value: previous.count ?? 0,
              }
            : { labelKey: `${PREFIX}.replacesNone`, value: previous?.count ?? 0 },
    ];
};

/** Save is only offered for a dry run that passed and would actually write venues. */
export const canSaveAllowedVenues = (preview: AllowedVenueUploadResponse | null): boolean =>
    preview?.success === true && (preview.summary?.inserted ?? 0) > 0;

export const shownRejections = (summary: AllowedVenueUploadSummary) =>
    summary.rejections.slice(0, REJECTIONS_SHOWN);
